export function getColorStylePropertyValue(value) {
  return value?.startsWith('var')
    ? getComputedStyle(document.body).getPropertyValue(
        value.slice(4, value.length - 1)
      )
    : value
}

export function toCSSPixel(value) {
  return Number.isFinite(value) ? `${value}px` : null
}
